function smoothScroll() {
  const linkElements = document.querySelectorAll('.header__nav a[href^="#"]');

  linkElements.forEach((element) => {
    element.addEventListener('click', (event) => {
      event.preventDefault();

      const href = element.getAttribute('href');
      const scrollIntoEl = document.querySelector(href);

      scrollIntoEl.scrollIntoView({
        behavior: 'smooth',
      });

      if (window.history.pushState) {
        window.history.replaceState(null, null, window.location.pathname + href);
      }
    });
  });
}

smoothScroll();
